import { useEffect } from 'react'

import { useGrowthBook } from '@growthbook/growthbook-react'

export const useSetEnvironmentAttributes = (): null => {
    const growthbook = useGrowthBook()

    useEffect(() => {
        if (!growthbook) return

        growthbook.setAttributes({
            ...growthbook.getAttributes(),
            build_environment: process.env.GATSBY_ACTIVE_ENV,
        })
    }, [growthbook])

    return null
}
